/**
 * @file Re-exports the Investment component.
 */
import Investment from "./Investment";

export default Investment;
